export const isSafeConnectionUrl = (candidate: unknown): boolean => {
    if (typeof candidate !== 'string') {
        return false;
    }
    const value = candidate.trim();
    if (value === '') {
        return false;
    }

    const normalized = value.replace(/\\/g, '/');

    if (normalized.startsWith('//')) {
        return false;
    }

    let absolute: URL | null = null;
    try {
        absolute = new URL(value);
    } catch {
        absolute = null;
    }

    if (absolute) {
        if (absolute.protocol !== 'https:') {
            return false;
        }
        if (absolute.username !== '' || absolute.password !== '') {
            return false;
        }
        return true;
    }

    return true;
};

export default isSafeConnectionUrl;
